import PropTypes from 'prop-types';
import React from 'react';

import * as nyc from 'ui-library/NYC';
import {StageRunGraph} from 'workflows/visualization/TaggedNodeGraph';

import WorkflowDetailsTable from './components/WorkflowDetailsTable';
import {
  STAGE_CONFIGURATION_FULL_SHAPE,
  STAGE_ENTRY_FULL_SHAPE,
  STAGE_ENTRY_SUMMARY_DATA,
  STAGE_RUN_FULL_SHAPE,
  STAGE_RUN_SAMPLE_FULL_SHAPE,
  StageConfiguration,
  StageEntryDocument,
  StageEntrySummaryData,
  StageRun,
  StageRunSample,
  Workflow,
  WORKFLOW_FULL_SHAPE,
  WORKFLOW_STAGE_FULL_SHAPE,
  WORKFLOW_STRUCTURED_DATA_SHAPE,
  WorkflowStage,
  WorkflowStructuredData,
} from './WorkflowConstants';
import WorkflowDetailsHeader from './WorkflowDetailsHeader';

export interface WorkflowDetailsScreenProps {
  isExpanded: boolean;
  stageIdToStageEntries: {[stageId: string]: Array<StageEntryDocument>};
  stageIdToStageRuns: {[stageId: string]: Array<StageRun>};
  stageIdToStageConfiguration: {[stageId: string]: StageConfiguration};
  stageIdToStructuredData: {[stageId: string]: WorkflowStructuredData};
  stageRunGraph: StageRunGraph;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
  workflow: Workflow;
  workflowStages: Array<WorkflowStage>;
  entryIdToSummaryData?: {[entryId: string]: StageEntrySummaryData};
}

export default function WorkflowDetailsScreen(props: WorkflowDetailsScreenProps): JSX.Element {
  return (
    <nyc.Container className="expandedContainer--fullScreen" size="lg">
      <WorkflowDetailsHeader
        workflow={props.workflow}
        workflowStages={props.workflowStages}
        stageIdToStageRuns={props.stageIdToStageRuns}
        stageIdToStageConfiguration={props.stageIdToStageConfiguration}
        stageRunGraph={props.stageRunGraph}
        isExpanded={props.isExpanded}
      />
      <nyc.Row fluid={true}>
        <nyc.Col className="u-flex-display u-vertical-flex" lg={22}>
          <WorkflowDetailsTable
            isExpanded={props.isExpanded}
            stageIdToStageEntries={props.stageIdToStageEntries}
            stageIdToStageRuns={props.stageIdToStageRuns}
            stageIdToStageConfiguration={props.stageIdToStageConfiguration}
            stageIdToStructuredData={props.stageIdToStructuredData}
            stageRunGraph={props.stageRunGraph}
            stageRunSampleById={props.stageRunSampleById}
            workflowStages={props.workflowStages}
            workflow={props.workflow}
            isWorkflowEditable={props.workflow.permissions.writable}
            entryIdToSummaryData={props.entryIdToSummaryData}
          />
        </nyc.Col>
      </nyc.Row>
    </nyc.Container>
  );
}

WorkflowDetailsScreen.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  stageIdToStageEntries: PropTypes.objectOf(PropTypes.arrayOf(STAGE_ENTRY_FULL_SHAPE.isRequired).isRequired)
    .isRequired,
  stageIdToStageRuns: PropTypes.objectOf(PropTypes.arrayOf(STAGE_RUN_FULL_SHAPE)).isRequired,
  stageIdToStageConfiguration: PropTypes.objectOf(STAGE_CONFIGURATION_FULL_SHAPE.isRequired).isRequired,
  stageIdToStructuredData: PropTypes.objectOf(WORKFLOW_STRUCTURED_DATA_SHAPE.isRequired).isRequired,
  stageRunGraph: PropTypes.object.isRequired,
  stageRunSampleById: PropTypes.objectOf(STAGE_RUN_SAMPLE_FULL_SHAPE.isRequired).isRequired,
  workflow: WORKFLOW_FULL_SHAPE.isRequired,
  workflowStages: PropTypes.arrayOf(WORKFLOW_STAGE_FULL_SHAPE.isRequired).isRequired,
  entryIdToSummaryData: PropTypes.objectOf(STAGE_ENTRY_SUMMARY_DATA.isRequired),
};
